module.exports = __webpack_public_path__ + "static/media/8900_FamilyRoom.1cffb61e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_FamilyRoom.jpg
// module id = 574
// module chunks = 0